module.exports = __webpack_public_path__ + "media/assets/images/blog/pexels-dio-hasbi-saniskoro-3280130-small-200696abea72a31e9a8a912523f600ac.jpg";